<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>
          List of Contacts
          <FilterName :currentFilter="savedFilter" />
        </h4>
        <Toolbar class="p-mb-4">
          <template slot="left">
            <span class="p-input-icon-left mb-2">
              <div class="p-inputgroup">
                <Button
                  icon="pi pi-fw pi-refresh"
                  class="p-mr-1"
                  @click="setupComponentData(1)"
                />
                <Button
                  icon="pi pi-fw pi-cog"
                  class="p-mr-1"
                  @click="openColumnsSelection()"
                />
                <InputText
                  v-model="searchText"
                  placeholder="Global Search"
                  @input="updateSearch"
                />
                <Button
                  icon="pi pi-times p-pr-1"
                  class="p-mr-1"
                  @click="closeSearch"
                />
                <div
                  :class="getClassForQuickFiltersDiv()"
                  :key="quickFiltersDivKey"
                >
                  <Button
                    style="width: 50px; top: 50%; transform: translate(0%, -50%);"
                    @click="
                      quickFilterDialog = true;
                      quickFilterDialogKey++;
                    "
                    icon="pi pi-filter"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                    :badge="getBadgeForQuickFilters().toString()"
                  />
                  <Button
                    v-if="isEmpty()"
                    @click="clearQuickFilter()"
                    icon="pi pi-times"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                  />
                </div>
              </div>
            </span>
          </template>
          <template slot="right">
            <div class="p-input-icon-left mb-2">
              <Button
                style="height: 36px;"
                @click="makeFavorite()"
                :icon="favorite ? 'pi pi-star' : 'pi pi-star-o'"
                class="p-mr-1 p-button-text p-button-danger mb-2"
                :disabled="
                  !(savedFilter && savedFilter.id) || favoriteRequesting
                "
              />
              <Dropdown
                v-model="savedFilter"
                :options="savedFilters"
                optionLabel="filterName"
                dataKey="id"
                placeholder="Select Saved Filter"
                :showClear="true"
                class="mb-2"
                style="width: 200px;"
              >
                <template #option="slotProps">
                  {{ slotProps.option.filterName }}
                </template>
              </Dropdown>
              <Button
                style="height: 36px;"
                @click="editSelectedFilter()"
                icon="pi pi-pencil"
                class="p-mx-1 mb-2"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                style="height: 36px;"
                @click="deleteSavedFilterWarning = true"
                icon="pi pi-trash"
                class="p-mr-1 p-button-danger mb-2"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                label="New filter"
                icon="pi pi-plus"
                class="p-button-success p-mt-1 mb-2"
                @click="newFilter()"
              />
              <Button
                label="New Contact"
                icon="pi pi-plus"
                class="p-button-success p-mr-2 ml-2 mt-1 mb-2"
                style="margin-right: 1em"
                @click="openNew"
              />
            </div>
          </template>
        </Toolbar>
      </div>
    </div>

    <Dialog
      :key="quickFilterDialogKey"
      :visible.sync="quickFilterDialog"
      :style="{ width: '500px', overflowY: 'auto' }"
      header="Quick Filters"
      :modal="true"
      class="p-fluid"
    >
      <div v-for="(element, index) in dbViewFieldsForQuickFilters" :key="index">
        <div v-if="element.quickFilter === true" class="p-formgrid p-grid">
          <div class="p-field p-col p-d-flex">
            <label class="p-as-center" :for="element.fieldName">
              {{ element.fieldName }}
            </label>
          </div>
          <div class="p-field p-col">
            <div v-if="isQuickFilterable(index)">
              <div v-if="getFieldType(index) === 'Date'" style="width: 250px;">
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  optionLabel="dateModifierName"
                  dataKey="id"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
                <div class="pt-1">
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesFrom[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date from"
                    style="width: 49%;"
                  />
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesTo[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date to"
                    style="width: 49%; float: right;"
                  />
                </div>
              </div>
              <div
                v-else-if="getFieldType(index) === 'Currency'"
                style="width: 250px;"
              >
                £
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 45%;"
                />
                £
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 45%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Number'"
                style="width: 250px;"
              >
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 49%;"
                />
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 49%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Yes/No'"
                style="width: 250px;"
              >
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
              </div>
              <div v-else style="width: 250px">
                <MultiSelect
                  filter
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element)[0]"
                  :dataKey="getDataKey(element)"
                  placeholder="Type to display options"
                  style="width: 100%"
                />
              </div>
            </div>
            <ProgressSpinner
              v-else
              style="width:30px; height:30px"
              strokeWidth="2"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          style="float: left;"
          label="Clear All Filters"
          icon="pi pi-times"
          class="p-button-danger"
          @click="clearQuickFilter()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-info"
          style="width: 100px;"
          @click="quickFilterDialog = false"
        />
        <Button
          label="Apply Filters"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 130px;"
          @click="setupQuickFilter()"
        />
      </template>
    </Dialog>

    <Dialog header="Header" :visible.sync="deleteSavedFilterWarning">
      <template #header>
        <h3>Delete Alert</h3>
      </template>

      Are you sure you want to delete this filter?

      <template #footer>
        <Button
          @click="deleteSavedFilterWarning = false"
          label="No"
          icon="pi pi-times"
          class="p-button-success"
          style="width: 80px;"
        />
        <ProgressSpinner
          v-if="deleteRequesting"
          style="width:25px; height:25px; width: 80px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          @click="deleteSavedFilter()"
          label="Yes"
          icon="pi pi-check"
          autofocus
          class="p-button-danger"
          style="width: 80px;"
        />
      </template>
    </Dialog>

    <ProgressSpinner
      v-if="firstRequesting"
      style="width:50px; height:50px;"
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <div v-else style="width: 100%;">
      <component
        :is="tableComponent"
        :dbView="dbView"
        :colSelectedFieldsForTable="colSelectedFieldsForTable"
        :colSelectedFields="colSelectedFields"
        :dbViewFields="dbViewFields"
        :contacts="contacts"
        :loading="loading"
        :totalRecords="totalRecords"
        :rows="rows"
        :currentPage="currentPage"
        :reloadTable="realoadLazyTable"
        @reload="reload"
        @edit-contact="editContact"
        @delete-contact="deleteContact"
        @lazyNext="lazyNext"
        @sortChange="sortChange"
        @colSaved="colSaved()"
        @colUpdated="colUpdated"
        :makingExport="makingExport"
        @exportData="exportData"
        :storeName="listViewModule"
      />
    </div>

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

    <FilterForm
      v-if="filterFormDialog"
      :filterForm="filterFormDialog"
      :getDBViewFieldsId="dbView"
      :filterToEdit="filterToEdit"
      @close="filterFormDialog = false"
      @saved="filterSaved()"
    />

    <component
      :is="formComponent"
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactFormDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog="contactFormDialog = false"
      @submit-contact-form="savedContact"
    />

    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      @hide-duplicate-dialog="duplicateDialog = false"
      @submit-duplicate-form="saveDuplicate"
    />
  </div>
</template>

<script>
import { editedFilterIsCurrent } from "@/mbp/editedFilterIsCurrent";
import ContactService from "@/service/ContactService";
import FiltersService from "@/service/FiltersSerice";
import CustomerService from "@/service/CustomerService";

import ContactsTableForLazyLoading from "../universalComponents/contact/ContactsTableForLazyLoadingWithResize";
import ColumnSelection from "../universalComponents/columnSelection/ColumnSelection";
import FilterForm from "../universalComponents/filter/filterForm";
import FilterName from "../universalComponents/general/filterName";
import ContactForm from "../universalComponents/contact/contactForm";
import DuplicateDialog from "../universalComponents/contact/duplicateDialog";
import PermissionMixin from "../PermissionMixin.vue";
import moment from "moment";

import ListViewStateMixin from "../ListViewStateMixin.vue";
import { savedFilterChanged } from "../savedFilterChanged.js";

export default {
  // Vuex module holding this list's persisted filter/sort/page/scroll state.
  // Shares the 'contacts' module with the old contacts list, as it always has.
  // See the note in src/listViewRegistry.js before splitting them.
  listViewModule: "contacts",
  components: {
    ContactsTableForLazyLoading,
    ColumnSelection,
    FilterForm,
    DuplicateDialog,
    FilterName
  },
  created() {
    this.setupComponent();
  },
  mixins: [PermissionMixin, ListViewStateMixin],
  data: () => ({
    contactService: new ContactService(),
    customerService: new CustomerService(),
    filtersService: new FiltersService(),

    dbView: 9,
    filterFormDialog: false,
    savedFilters: null,
    savedFilter: null,
    contacts: [], // For whole data set
    contact: {},
    contactToEdit: {},
    contactFormDialog: false,
    displayDuplicateMessage: false,
    duplicateInfo: {},
    messages: [],
    dbViewFields: [],
    dbViewFieldsForQuickFilters: [],
    quickFiltersSelection: [],
    datesFrom: [],
    datesTo: [],
    quickFiltersOptions: [],
    tableKey1: 0,
    contactDisabledArr: [],
    columnSelectionDialog: false,
    defaultView: true,
    colSelectedFields: [],
    colSelectedFieldsForTable: [],
    duplicates: [],
    requesting: false,
    tableKey1: 0,
    realoadLazyTable1: 0,
    deleteSavedFilterWarning: false,
    quickFilterDialogKey1: 0,
    quickFilterDialog: false,
    filterToEdit: {},
    reloadContactForm: 0,
    duplicateContact: {},
    duplicateToSend: {},
    duplicateDialogKey1: 0,
    duplicateDialog: false,
    quickFiltersDivKey1: 0,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
    deleteRequesting: false,
    favoriteRequesting: false,
    favorite: false,

    searchText: "",
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: "",
    sortFieldId: 0,
    sortOrder: 0,
    lastMainRequestBody: {},
    lastMainRequest: "",
    firstRequesting: true,
    forceReloadd: false,

    makingExport: false
  }),
  computed: {
    hardLoad() {
      return this.listViewGet("getHardLoad");
    },
    softReload() {
      return this.listViewGet("getSoftReload");
    },
    realoadLazyTable: {
      set() {
        this.tableKey1++;
      },
      get() {
        return "realoadLazyTable-" + this.tableKey1.toString();
      }
    },
    loading() {
      //
      if (this.contacts && this.contacts[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    quickFilterDialogKey: {
      set() {
        this.quickFilterDialogKey1++;
      },
      get() {
        return "quickFilterDialogKey-" + this.quickFilterDialogKey1.toString();
      }
    },
    tableComponent() {
      return this.firstRequesting === false
        ? ContactsTableForLazyLoading
        : null;
    },
    formComponent() {
      return this.firstRequesting === false || this.contactFormDialog
        ? ContactForm
        : null;
    },
    duplicateDialogKey: {
      set() {
        this.duplicateDialogKey1++;
      },
      get() {
        return "duplicateDialogKey-" + this.duplicateDialogKey1.toString();
      }
    },
    quickFiltersDivKey: {
      set(val) {
        this.quickFiltersDivKey1++;
      },
      get() {
        return "quickFiltersDivKey" + this.quickFiltersDivKey1.toString();
      }
    }
  },
  watch: {
    currentPage(val) {
      //
      this.listViewSet("setPage", {
        page: val,
        rows: this.listViewGet("getRows")
      });

      if (val === 1) {
        this.realoadLazyTable++;
      }
    },
    hardLoad(val) {
      //

      this.setupComponentData(1);
    },
    softReload(val) {
      //

      this.setupComponentData(0);
    },
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val);
      this.setupColumns();
    },
    colSelectedFieldsForTable(val) {
      this.realoadLazyTable++;
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a =>
    },
    savedFilter(val) {
      //

      if (val && (val.favourite !== null || val.favourite !== undefined)) {
        this.favorite = val.favourite;
      }

      let oldFilter = this.listViewGet("getMainListSavedFilter");

      this.listViewSet("setMainListSavedFilter", val);

      if (savedFilterChanged(oldFilter, val)) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    dbViewFieldsForQuickFilters(val) {
      //
      if (
        !this.quickFiltersSelection.every(
          element => element === undefined || element === null
        )
      ) {
        this.getDataFromSource();
      }
    },
    dbViewFields(val) {
      this.setupViewFieldsForQuickFilters();

      //
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView);
      }
      // this.colSelectedFieldsForTable.forEach(a =>
    },
    quickFiltersSelection(val) {
      //
      this.listViewSet("setMainListQuickFilters", val);
    },
    datesFrom(val) {
      this.listViewSet("setQuickFiltersDatesFrom", val);
    },
    datesTo(val) {
      this.listViewSet("setQuickFiltersDatesTo", val);
    },
    contactFormDialog(val) {
      this.reloadContactForm++;
    },
    duplicateDialog(val) {
      this.duplicateDialogKey++;
    }
  },
  methods: {
    makeFavorite() {
      this.favorite = !this.favorite;

      this.favoriteRequesting = true;
      this.filtersService
        .setSavedFilterFav(this.savedFilter.id, this.favorite ? 1 : 0)
        .then(data => {
          let filterIndex = this.savedFilters.findIndex(
            filter => filter.id === this.savedFilter.id
          );
          if (filterIndex >= 0) {
            this.savedFilters[filterIndex].favourite = this.favorite;
          }
          this.favoriteRequesting = false;
        })
        .catch(error => {
          this.favoriteRequesting = false;
          this.favorite = !this.favorite;

          this.$toast.add({
            severity: "error",
            summary: "Can't change favorite...",
            detail: "Error while changing favorite status of this filter.",
            life: 5000
          });
        });
    },
    resetCols() {
      this.resettingColumns = true;

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false;
          this.columnSelectionDialog = false;
          this.colSelectedFields = data;
          this.getDBViewFields();
        })
        .catch(error => {
          this.resettingColumns = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000
          });
        });
    },
    colUpdated(obj) {
      if (obj) {
        var id = obj.id,
          width = obj.width;
        //
        let a = this.colSelectedFields.findIndex(b => b.id === id);
        if (a >= 0 && this.colSelectedFields[a]) {
          this.colSelectedFields[a].width = width;
        }
      }
    },
    setupComponent() {
      this.firstRequesting = true;

      // setTimeout(() => {
      //
      //   if (!this.forceReloadd) {
      let a = this.listViewGet("getFirstTimeLoad");

      if (a) {
        this.listViewSet("setFirstTimeLoad", false);
        this.setupComponentData(1);
      } else {
        this.setupComponentData(0);
      }
      //   }
      // }, 50)

      this.getUserViewFilters();

      this.getColumnSelection();

      this.getDBViewFields();
    },
    setupComponentData(hardLoad) {
      if (hardLoad) {
        this.forceReloadd = true;

        // setup sort

        this.sortField = "";
        this.sortFieldId = 0;
        this.sortOrder = 0;
        this.listViewSet("setSort", {
          sortField: this.sortField,
          sortFieldId: this.sortFieldId,
          sortOrder: this.sortOrder
        });

        // setup page and rows

        this.rows = 25;
        this.currentPage = 1;
        this.listViewSet("setPage", {
          page: this.currentPage,
          rows: this.rows
        });

        this.realoadLazyTable++;

        // setup search

        this.searchText = "";
        this.syncSearchToUrl("");

        // A hard load is a deliberate reset, so drop the stored scroll offset
        // too - otherwise the reset list would jump back down the page.
        this.persistScrollY(0);
        this.persistGridScrollY(0);

        // setup quick filters

        this.quickFiltersSelection = [];
        this.datesFrom = [];
        this.datesTo = [];
        this.listViewSet("setMainListQuickFilters",
          this.quickFiltersSelection
        );
        this.listViewSet("setQuickFiltersDatesFrom",
          this.datesFrom
        );
        this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

        // setup savedfilter

        this.getDefUserViewFilter()
          .then(savedFilter => {
            if (!savedFilter) {
              this.getDataFromSource();
            } else {
              this.savedFilter = savedFilter;
            }
          })
          .catch(err => {
            this.getDataFromSource();
          });
      } else {
        // setup sort

        if (this.listViewGet("getSortField")) {
          this.sortField = this.listViewGet("getSortField");
          this.sortFieldId = this.listViewGet("getSortFieldId");
          this.sortOrder = this.listViewGet("getSortOrder");
        }

        // setup page and rows

        this.rows = this.listViewGet("getRows");
        this.currentPage = this.listViewGet("getPage");

        // setup search

        this.searchText = this.$route.query.search || this.listViewGet("getSearchText") || "";

        // setup quick filters

        this.quickFiltersSelection = [
          ...this.listViewGet("getMainListQuickFilter")
        ];
        this.datesFrom = [
          ...this.listViewGet("getQuickFiltersDatesFrom")
        ];
        this.datesTo = [
          ...this.listViewGet("getQuickFiltersDatesTo")
        ];

        // setup savedfilter

        this.savedFilter = {
          ...this.listViewGet("getMainListSavedFilter")
        };

        // Re-entering the list, so put the user back where they were. This
        // waits for the lazy grid to render before scrolling.
        this.restoreListScroll();
      }
    },
    getDataFromSource() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }

      var cancelRequest = false;

      //

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      //
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0)
                          quickFilters[a] = this.quickFiltersSelection[i]
                            .map(item => {
                              return item[
                                this.dbViewFieldsForQuickFilters[i].dbIdField
                              ];
                            })
                            .join(",");
                      }
                    }
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    //
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }
      //
      var thisMainRequestBody = JSON.stringify(quickFilters);

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      var thisRequest = `${savedFilter1}/${this.currentPage}/${this.rows}/${this.sortFieldId}/${this.sortOrder}/${searchQuery}`;

      if (!cancelRequest) {
        if (
          !(
            thisRequest === this.lastMainRequest &&
            thisMainRequestBody === this.lastMainRequestBody
          ) ||
          this.forceReloadd
        ) {
          this.forceReloadd = false;

          this.lastMainRequest = thisRequest;
          this.lastMainRequestBody = thisMainRequestBody;

          this.requesting = true;
          this.contacts = [];

          quickFilters.searchText = searchQuery;

          this.contactService
            .getLazyContacts2(
              savedFilter1,
              this.currentPage,
              this.rows,
              this.sortFieldId,
              this.sortOrder,
              "*",
              quickFilters
            )
            .then(response => {
              //

              let responseData = JSON.parse(response.config.data),
                a = response.config.url.split("/");

              a[8] = responseData.searchText;

              let b = a.map(c => parseInt(c));

              delete responseData.searchText;
              responseData = JSON.stringify(responseData);

              if (
                a[8] === "*" &&
                this.searchText === "" &&
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.contacts = response.data;
              } else if (
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                a[8] === this.searchText &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.contacts = response.data;
              }
            })
            .catch(err => {
              this.requesting = false;

              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: `Error while getting contacts for saved filter ${savedFilter1} and search text ${this.searchText}`,
                life: 5000
              });
            });
        }
      }
    },
    sortChange({ sortField, sortFieldId, sortOrder }) {
      this.listViewSet("setSort", {
        sortField,
        sortFieldId,
        sortOrder
      });

      this.sortField = sortField;
      this.sortFieldId = sortFieldId;
      this.sortOrder = sortOrder;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    lazyNext({ page, rows, totalPages }) {
      this.listViewSet("setPage", { page, rows });

      this.rows = rows;
      this.totalPages = totalPages;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }

      this.getDataFromSource();
    },
    setupQuickFilter() {
      this.quickFilterDialog = false;
      //
      this.listViewSet("setMainListQuickFilters",
        this.quickFiltersSelection
      );
      this.listViewSet("setQuickFiltersDatesFrom", this.datesFrom);
      this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

      this.getDataFromSource();
    },
    closeSearch() {
      this.searchText = "";
      this.syncSearchToUrl("");

      this.getDataFromSource();
    },
    updateSearch(e) {
      this.searchText = e;
      this.syncSearchToUrl(e);

      this.getDataFromSource();
    },
    checkExistanceOfFilterFldId(quickFilterOptionsList, index) {
      try {
        // this.quickFiltersSelection[index] = quickFilterOptionsList.find(a => a[this.dbViewFields[index].dbIdField] ===  this.dbViewFields[index].filterDefId)
      } catch (e) {}
    },
    setupViewFieldsForQuickFilters() {
      var duplicateDate = [];

      this.dbViewFields.forEach(d => {
        // if (d.fieldName === "Start Date") {
        //   duplicateDate.push({...d, dbField: "startDateFrom", fieldName: "Start Date From"})
        //   duplicateDate.push({...d, id: d.id + '1', dbField: "startDateTo", fieldName: "Start Date To"})

        // } else {
        duplicateDate.push(d);
        // }
      });

      this.dbViewFieldsForQuickFilters = [];

      var notExists = this.quickFiltersSelection.every(
        element => element === undefined || element === null
      );

      //

      duplicateDate.forEach((d, index) => {
        this.dbViewFieldsForQuickFilters.push(d);

        //

        if (d.quickFilter) {
          if (d.fieldType === "Date") {
            this.filtersService
              .getDateModifiers()
              .then(data => {
                this.quickFiltersOptions[index] = data;
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              })
              .catch(err => {
                // this.$toast.add({
                //   severity: "error",
                //   summary: "Error",
                //   detail: "Error while getting date modifiers",
                //   life: 5000,
                // })
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content: 'Some data was not loaded from "dateModifiers"'
                });
              });
          } else if (d.lovEP) {
            //
            if (d.lovEP === "YES/NO") {
              this.quickFiltersOptions[index] = [
                { id: 1, [d.dbField]: "Yes" },
                { id: 2, [d.dbField]: "No" }
              ];
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            } else if (d.lovEP.substr(0, 1) === "*") {
              let list = d.lovEP.substr(1).split("/");
              if (list.length) {
                this.quickFiltersOptions[index] = list.map((a, index) => {
                  return { id: index, [d.dbField]: a };
                });
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              }
            } else {
              this.filtersService
                .filtersCustomRequest(d.lovEP)
                .then(data => {
                  this.quickFiltersOptions[index] = data;
                  this.checkExistanceOfFilterFldId(
                    this.quickFiltersOptions[index],
                    index
                  );
                })
                .catch(err => {
                  if (err && err.response && err.response.status !== 200) {
                    // this.$toast.add({
                    //   severity: "error",
                    //   summary: "Error",
                    //   detail: "Error while getting quick filters",
                    //   life: 5000,
                    // })
                    this.$store.dispatch("addErrorMessage", {
                      severity: "error",
                      content: `Some data was not loaded from "${d.lovEP}"`
                    });
                  }
                });
            }
          }
        }
        if (notExists) {
          this.quickFiltersSelection.push(null);
        }
        this.quickFiltersOptions.push({});
        //
      });

      //
      //
    },
    getDefUserViewFilter() {
      return new Promise(async (resolve, reject) => {
        this.filtersService
          .getDefUserViewFilter(this.dbView)
          .then(data => resolve(data))
          .catch(err => {
            this.savedFilter = {};

            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting default user view filter.",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "defUserViewFilter/{dbView}"'
            });
            reject();
          });
      });
    },
    getUserViewFiltersByHard() {
      this.filtersService
        .getUserViewFiltersByHard(this.dbView)
        .then(data => {
          //
          let obj = { ...this.savedFilter };

          this.savedFilters = data;
          if (obj && obj.id) {
            this.savedFilter = data.find(a => {
              if (a && a.id === obj.id) {
                return true;
              }
            });
          }
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer user filters",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    getUserViewFilters() {
      this.filtersService
        .getUserViewFilters(this.dbView)
        .then(data => {
          //
          this.savedFilters = data;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting contacts user filters",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    setupColumns() {
      if (
        this.colSelectedFields &&
        this.colSelectedFields[0] &&
        this.columnSelectionDialog
      ) {
        this.reloadColumnSelectionComponent++;
      }

      let a = [];
      this.colSelectedFields.forEach(b => {
        //
        let c = a.find(d => d.dbField === b.dbField.dbField);
        //
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = {
            ...b.dbField,
            defWidth: b.width
          };
        }
      });

      if (a.length) {
        this.colSelectedFieldsForTable = a;
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => (this.dbViewFields = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting contacts DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          });
        });
    },
    isEmpty() {
      //
      return !(
        this.quickFiltersSelection.every(
          element => element === undefined || element === null
        ) &&
        this.datesFrom.every(
          element => element === undefined || element === null
        ) &&
        this.datesTo.every(element => element === undefined || element === null)
      );
    },
    getBadgeForQuickFilters() {
      //
      let count = 0;
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        if (
          this.quickFiltersSelection[i] ||
          this.datesFrom[i] ||
          this.datesTo[i] ||
          this.datesFrom[i] === 0 ||
          this.datesTo[i] === 0
        ) {
          if (Array.isArray(this.quickFiltersSelection[i])) {
            if (this.quickFiltersSelection[i].length > 0) count++;
          } else {
            count++;
          }
        }
      }
      //
      return count;
    },
    getClassForQuickFiltersButon() {
      if (this.isEmpty()) {
        return "p-button-success";
      } else {
        return "p-button-info";
      }
    },
    getClassForQuickFiltersDiv() {
      if (this.isEmpty()) {
        return "greenBackground";
      } else {
        return "defaultBackground";
      }
    },
    isQuickFilterable(index) {
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].quickFilter
        ? this.dbViewFieldsForQuickFilters[index].quickFilter
        : false;
    },
    getFieldType(index) {
      //
      //
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].fieldType
        ? this.dbViewFieldsForQuickFilters[index].fieldType
        : "";
    },
    setSelection({ value, index }) {
      this.quickFiltersSelection[index] = value;
    },
    useAutoComplete(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterAutocomplete
        : false;
    },
    showDropdown(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    isForceSelection(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? !this.dbViewFieldsForQuickFilters[index].filterAllowStartWith
        : false;
    },
    getOptions(index) {
      return Array.isArray(this.quickFiltersOptions[index])
        ? this.quickFiltersOptions[index]
        : [];
    },
    getDataKey(data) {
      return data ? data.dbIdField : null;
    },
    getOptionLabel(data) {
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField];
        } else {
          return data ? data.dbField.split(".").slice(-1) : [];
        }
      }
    },
    showDateRanges(index) {
      //
      if (
        this.quickFiltersSelection[index] &&
        this.quickFiltersSelection[index].dateModifierFunc === "custom"
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickFiltersSelections() {
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        this.quickFiltersSelection[i] = null;
        this.datesFrom[i] = null;
        this.datesTo[i] = null;
      }
      this.quickFiltersDivKey++;
    },
    clearQuickFilter() {
      this.quickFilterDialog = false;
      this.clearQuickFiltersSelections();

      this.getDataFromSource();
    },
    editSelectedFilter() {
      this.filterToEdit = { ...this.savedFilter };
      this.filterFormDialog = true;
    },
    newFilter() {
      this.filterToEdit = {};
      this.filterFormDialog = true;
    },
    reload() {
      this.forceReloadd = true;
      this.setupComponentData(0);
    },
    updateDefaultFilter() {
      this.filtersService
        .getDefUserViewFilterByHard(this.dbView)
        .then(data => {})
        .catch(error => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while updating default filter.",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "defUserViewFilter/{dbView}"'
          });
        });
    },
    filterSaved() {
      this.filterFormDialog = false;
      this.getUserViewFiltersByHard();
      this.updateDefaultFilter();

      // UI1d: an edit of the filter in use reloads the list (it kept the old rows)
      const editedCurrent = editedFilterIsCurrent(this.filterToEdit, this.savedFilter);
      this.filterToEdit = {};
      if (editedCurrent) this.reload();
    },
    colSaved() {
      this.columnSelectionDialog = false;

      this.getColumnSelectionByHard();
      this.getDBViewFields();
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true;
      this.reloadColumnSelectionComponent++;
    },
    deleteContact(contact) {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "DeleteContact"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to delete a contact",
            life: 5000
          });
        } else if (permission.permissionLevel === 1) {
          if (contact && contact.contactId) {
            this.contactService
              .deleteContact(contact.contactId)
              .then(data => {
                this.reload();

                this.$toast.add({
                  severity: "success",
                  summary: "Deleted successfully.",
                  detail: `Contact ${contact.firstName} ${contact.lastName} has been deleted successfully'`,
                  life: 5000
                });
              })
              .catch(error => {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Contact could not be deleted. Make sure there are no related records such as Tasks, Events or Quotations linked to this contact. Also make sure the contact is not the key contact for '${
                    contact.custName ? contact.custName : ""
                  }'`,
                  life: 10000
                });
              });
          }
        }
      }
    },
    editContact(contact) {
      this.contactToEdit = contact;
      this.contactDisabledArr = ["country"];
      this.contactFormDialog = true;
    },
    openNew() {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "AddNewContact"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new contact",
            life: 5000
          });
        } else if (permission.permissionLevel === 1) {
          this.contactToEdit = { country: "UK" };
          this.contactDisabledArr = ["country"];
          this.contactFormDialog = true;
        }
      }
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      this.contactToEdit = {};
      this.contactFormDialog = false;
      if (duplicateToSend) {
        this.duplicateToSend = duplicateToSend;
        this.duplicateContact = duplicateContact;
        this.duplicateDialog = true;
      } else {
        this.reload();
      }
    },
    saveDuplicate() {
      this.duplicateDialog = false;

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000
            });

            this.reload();
          }
        })
        .catch(err => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving the contact",
            life: 5000
          });
        });
    },
    deleteSavedFilter() {
      if (this.savedFilter && this.savedFilter.id) {
        this.deleteRequesting = true;

        this.filtersService
          .deleteFilter(this.savedFilter.id)
          .then(data => {
            this.deleteRequesting = false;
            this.deleteSavedFilterWarning = false;
            this.getUserViewFiltersByHard();
          })
          .catch(error => {
            this.deleteRequesting = false;
            this.$toast.add({
              severity: "error",
              summary: "Unable to delete.",
              detail: "Got some error while deleting this filter.",
              life: 5000
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "A filter is required",
          detail: "Please select a saved filter first.",
          life: 5000
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          let a = v,
            parts = j.split(".");
          parts.forEach(part => {
            if (a) {
              a = a[part];
            }
          });
          if (a === true) {
            return "Yes";
          } else if (a === false) {
            return "No";
          } else {
            return a;
          }
        })
      );
    },
    exportData() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      //
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0)
                          quickFilters[a] = this.quickFiltersSelection[i]
                            .map(item => {
                              return item[
                                this.dbViewFieldsForQuickFilters[i].dbIdField
                              ];
                            })
                            .join(",");
                      }
                    }
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    //
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      quickFilters.searchText = searchQuery;

      this.checkPermissions();
      if (savedFilter1 || Object.keys(quickFilters).length > 1) {
        if (this.exportFilterToExcel === false) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You don't have permission to export this data",
            life: 5000
          });
          return;
        }
      } else if (this.exportAllToExcel === false) {
        this.$toast.add({
          severity: "error",
          summary: "Not allowed",
          detail: "You don't have permission to export this data",
          life: 5000
        });
        return;
      }
      import("@/service/Export2Excel").then(excel => {
        this.makingExport = true;
        this.contactService
          .getLazyContacts2(savedFilter1, 1, 100000, 0, 0, "*", quickFilters)
          .then(response => {
            //

            if (response.data) {
              const tHeader = [
                "Id",
                "Contact Name",
                "House",
                "Street",
                "Sub Area",
                "City/Town",
                "Post Code",
                "Job Title",
                "Contact Code",
                "Contact Name",
                "Customer Code",
                "Customer Name",
                "Customer Type Name",
                "Main Branch Code",
                "Sales Exec Name",
                "Job Function Name",
                "Job Title",
                "Key Contact Name",
                "Salutation",
                "Region",
                "Phone No.",
                "Mobile",
                "Email",
                "Notes",
                "Can Call?",
                "Can Email?",
                "Can Mail?",
                "Is Key Contact?",
                "Created By",
                "Date Created",
                "Updated By",
                "Date Updated"
              ];
              const filterVal = [
                "contactId",
                "contactName",
                "address1",
                "address2",
                "address3",
                "cityTownName",
                "postCode",
                "contactJobTitle",
                "contactCode",
                "contactName",
                "custCode",
                "custName",
                "customerTypeName",
                "mainBranchCode",
                "mainSalesExecName",
                "jobFunctionName",
                "jobTitle",
                "keyContactName",
                "salutation",
                "regionName",
                "phoneNo",
                "mobile",
                "email",
                "notes",
                "canCall",
                "canEmail",
                "canMail",
                "isKeyContact",
                "createdBy",
                "dateCreated",
                "updatedBy",
                "dateUpdated"
              ];
              console.log(response.data);
              const data = this.formatJson(filterVal, response.data);
              console.log(data);
              //
              let a = new Date(),
                date =
                  a.getDate() +
                  "_" +
                  a.getMonth() +
                  1 +
                  "_" +
                  a.getFullYear() +
                  "-" +
                  a.getHours() +
                  "_" +
                  a.getMinutes() +
                  "_" +
                  a.getSeconds();

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "Contacts" + "-" + date,
                autoWidth: true,
                bookType: "xlsx"
              });
            }

            this.makingExport = false;
          })
          .catch(err => {
            this.makingExport = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting enquiries for exporting(0/1/100000/0/0/*)`,
              life: 5000
            });
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.greenBackground {
  background-color: #5c9434;
  width: 83px;
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px;
}
</style>
